import axios from 'axios';
import { BABYFACE_URL } from '../../../lib/routes/Routes';
import { ERROR_RETRY } from '../../../lib/Error';

export const updateConversionRequest = async ({
  itemId,
  imageFrameAlias,
  babyGender,
  message,
  photoFrame,
  note,
  hospitalName,
}) => {
  try {
    const response = await axios.put(
      BABYFACE_URL.concat(`/requests/${itemId}/info`),
      {
        infoType: 'conversion',
        imageFrameAlias,
        babyGender,
        message,
        photoFrame,
        note,
        hospitalName,
      },
    );
    return response.data;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};
